import api from '../../../api/client'

/**
 * Email & Notification Settings API Client
 */

// ── Email Account (SMTP) ──
export async function getEmailAccountSettings() {
  const { data } = await api.get('/email-settings/account')
  return data
}

export async function updateEmailAccountSettings(payload) {
  const { data } = await api.put('/email-settings/account', payload)
  return data
}

export async function testEmailConnection(testRecipient) {
  const { data } = await api.post('/email-settings/test-connection', {
    testRecipientEmail: testRecipient,
    testRecipient,
  })
  return data
}

// ── Email Templates ──
export async function listEmailTemplates(category = '') {
  const params = category && category !== 'ALL' ? { category } : {}
  const { data } = await api.get('/email-settings/templates', { params })
  return Array.isArray(data) ? data : []
}

export async function getEmailTemplate(templateId) {
  const { data } = await api.get(`/email-settings/templates/${templateId}`)
  return data
}

export async function createEmailTemplate(payload) {
  const { data } = await api.post('/email-settings/templates', payload)
  return data
}

export async function updateEmailTemplate(templateId, payload) {
  const { data } = await api.put(`/email-settings/templates/${templateId}`, payload)
  return data
}

export async function deleteEmailTemplate(templateId) {
  const { data } = await api.delete(`/email-settings/templates/${templateId}`)
  return data
}

// ── Approval Workflow Rules ──
export async function listWorkflowRules() {
  const { data } = await api.get('/email-settings/workflow-rules')
  return Array.isArray(data) ? data : []
}

export async function updateWorkflowRule(moduleCode, payload) {
  const { data } = await api.put(`/email-settings/workflow-rules/${moduleCode}`, payload)
  return data
}

// ── Audit Delivery Logs ──
export async function listDeliveryAuditLogs(params = {}) {
  const { data } = await api.get('/email-settings/audit-logs', { params })
  return data
}

// ── Error Formatting Utility ──
export function formatApiErrorMessage(err, fallback = 'Operation failed.') {
  const detail = err?.response?.data?.detail
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail)) {
    return detail.map((d) => (typeof d === 'string' ? d : d?.msg || JSON.stringify(d))).join(', ')
  }
  if (detail && typeof detail === 'object') {
    return detail.message || detail.msg || JSON.stringify(detail)
  }
  return err?.message || fallback
}

// ── Dropdown Options ──
export async function listUserOptions() {
  const { data } = await api.get('/options/users').catch(() => ({ data: [] }))
  return Array.isArray(data) ? data : []
}

export async function listRoleOptions() {
  const { data } = await api.get('/options/roles').catch(() => ({ data: [] }))
  return Array.isArray(data) ? data : []
}

